import axios from '@/libs/api.request'
//查询广告列表
export const apiBannerList = data => {
    return axios.request({
      url: '/banner/query-banner',
      method: 'post',
      data
    })
  }
//   新增或修改广告列表
  export const apiBannerSave = data => {
    return axios.request({
      url: '/banner/save-banner',
      method: 'post',
      data
    })
  }
  //删除banner
  export const apiBannerDelete = data => {
    return axios.request({
      url: '/banner/delete-banner',
      method: 'post',
      data
    })
  }